module.exports = __webpack_public_path__ + "img/tssbicon.4f41d499.svg";